import { GridColumns } from '@mui/x-data-grid';

export const columns: GridColumns = [
  {
    field: 'name',
    headerName: 'problems.statusFlows.columns.status',
    flex: 1,
    minWidth: 150,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'statusNumberOfChanges',
    headerName: 'clients.changes',
    flex: 1,
    minWidth: 50,
    headerAlign: 'center',
    align: 'center'
  }
];
